<template>
  <div
    id="failed-articles-list"
  >
    <div
      v-for="(article, index) in failedArticles"
      :key="index"
      class="bg-secondary p-3 border-bottom"
      :data-test="`failed-content-list-item-${index}`"
    >
      <p
        class="font-weight-bold  mb-4 cursor-pointer text-break"
      >
        <a
          :href="article.url"
          target="_blank"
        >
          {{ article.url }}
        </a>
      </p>
      <p
        class="tag tag-danger mb-4 px-2"
        data-test="content-list-item-status"
      >
        {{ article.status }}
      </p>
      <button
        class="btn btn-secondary px-2"
        @click="openManualyEnterContentModal(article.id)"
      >
        Manually Enter Content Item
      </button>
      <manually-enter-content-modal
        :article="article"
      />
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import * as contentTypes from '@/modules/content/store/types';

import ManuallyEnterContentModal from '@/modules/content/components/Articles/ManuallyEnterContentModal.vue';

export default {
  name: 'FailedScrapedContentItems',
  components: {
    ManuallyEnterContentModal,
  },
  data() {
    return {

    };
  },
  methods: {
    openManualyEnterContentModal(articleId) {
      this.$root.$emit('bv::show::modal', `ManuallyEnterContentModal${articleId}`);
    },
  },
  computed: {
    ...mapGetters('content', {
      failedArticles: contentTypes.GET_FAILED_SCRAPED_CONTENT_ITEMS,
    }),
  },
};
</script>
<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}
.failed-content-item {
  background-color: #eee;
  max-height: 200px;
  padding: 16px;
  border-top: 1px solid hsla(191, 67%, 14%, 0.12);
}
p {
  display: block;
}
a {
  color: inherit;
  text-decoration: none;
}
</style>
